<template>
  <div class="main-content-container pa-directory-container">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span class="breadcrumb--light font-family-medium text-uppercase">
            Team Directory
          </span>
        </b-breadcrumb-item>
      </b-breadcrumb>
      <h1 class="font-lg font-family-medium primary-dark content-title">
        Team Directory
      </h1>
      <div
        v-if="loaded && assistantsList.length"
        class="position-absolute grid-icon-container"
      >
        <img
          v-if="!showListView"
          class="cursor-pointer"
          @click="showListView = !showListView"
          src="@/assets/icons/card_grid.svg"
          alt
        />
        <img
          v-if="showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_list.svg"
          alt
          class="cursor-pointer"
        />
      </div>
      <!-- <b-dropdown-divider class="mt-0 mb-5 " /> -->
    </div>

    <!-- Adding b-tabs -->
    <b-tabs
      v-model="tabIndex"
      @input="getActiveTab"
      class=""
      active-nav-item-class="danger"
      active-tab-class="font-weight-bold text-success"
    >
      <!-- Active EAs -->
      <b-tab title="Active EAs">
        <div v-if="!showListView" class="d-flex grid-card-wrapper">
          <b-row class="w-100 d-flex flex-column" no-gutters>
            <b-row class="cards-wrapper">
              <b-col
                cols="6"
                md="4"
                lg="4"
                xl="3"
                class="card-column mb-5"
                v-for="assistant in assistantsList"
                :key="assistant.id"
              >
                <b-card
                  @click="goToPAContactInfo(assistant)"
                  @mouseenter="showCardHover(assistant.id)"
                  @mouseleave="undoCardHover(assistant.id)"
                  class="grid-card px-0"
                  style="height:100%"
                >
                  <div
                    style="min-height: 4.4rem"
                    class="d-flex justify-content-end pa-directory-cta position-relative"
                  >
                    <div class="d-flex">
                      <div
                        v-if="
                          role === 'admin' &&
                            assistant.role.name === 'assistant'
                        "
                      >
                        <div
                          v-if="
                            !deleteHover ||
                              (showInactiveDeleteHover &&
                                activeDeleteHoverId !== assistant.id)
                          "
                          class="empty-icon-avatar d-flex align-items-center justify-content-center"
                        >
                          <img
                            class="cursor-pointer"
                            @click.stop="showDeleteModal(assistant)"
                            src="@/assets/icons/arrow_down_square.svg"
                            alt
                          />
                        </div>
                        <div
                          class="archive-hover-avatar position-relative d-flex align-items-center justify-content-center"
                          v-if="
                            deleteHover && activeDeleteHoverId === assistant.id
                          "
                          @click.stop="showDeleteModal(assistant)"
                        >
                          <img
                            src="@/assets/icons/arrow_down_square_hover.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- <img src="@/assets/icons/arrow_down_square.svg" alt /> -->
                  </div>
                  <b-card-body class="text-center grid-card-body p-0">
                    <b-avatar
                      class="bg--primary mt-4"
                      v-if="assistant.user.avatarThumbnail"
                      :src="assistant.user.avatarThumbnail"
                      size="11.1rem"
                    ></b-avatar>
                    <b-avatar
                      class="bg--primary mt-4"
                      v-if="!assistant.user.avatarThumbnail"
                      :text="assistantInitials(assistant.user)"
                      size="11.1rem"
                    ></b-avatar>
                    <p class="font-family-medium primary--text mt-4">
                      {{
                        `${assistant.user.firstName} ${assistant.user.lastName}`
                      }}
                    </p>
                    <p
                      v-if="
                        role === 'admin' && assistant.role.name === 'assistant'
                      "
                      class="secondary--text reduce-whitespace"
                    >
                      {{
                        `${
                          assistant.assistantProfile &&
                          assistant.assistantProfile.workHours
                            ? workHoursToInteger(
                                assistant.assistantProfile.workHours
                              )
                            : ""
                        }`
                      }}
                      hours / week
                    </p>
                    <div
                      class="d-flex justify-content-center reduce-whitespace-2"
                    >
                      <b-button
                        v-if="assistant.role.name === 'assistant'"
                        class="text-uppercase mr-2 pt-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                        >{{
                          getAssistantJobTitle(
                            assistant.assistantProfile.jobTitle
                          )
                        }}
                      </b-button>
                      <b-button
                        v-if="assistant.role.name === 'admin'"
                        class="text-uppercase mr-2 pt-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                        >{{ getAssistantJobTitle("ADMIN") }}
                      </b-button>
                      <b-button
                        v-if="assistant.role.name === 'owner'"
                        class="text-uppercase mr-2 pt-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                        >{{ getAssistantJobTitle("OWNER") }}
                      </b-button>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
            <infinite-loading
              spinner="spiral"
              @infinite="infiniteHandlerTeam"
              :identifier="infiniteId"
              ><div slot="no-more">
                <h4 class="primary--text font-family-medium mb-5 mt-5">
                  No more EAs to load.
                </h4>
              </div>
              <div slot="no-results">
                <h4 class="primary--text font-family-medium mb-5 mt-5">
                  No more EAs to load.
                </h4>
              </div></infinite-loading
            >
          </b-row>
        </div>

        <b-row v-if="showListView">
          <b-col>
            <b-row class="justify-space-evenly list-view-header" no-gutters>
              <b-col cols="5" class="">
                <h6
                  class="font-sm position-relative primary--text font-family-medium"
                >
                  EA Name
                </h6>
              </b-col>
              <b-col cols="4" class="list-view-header">
                <h6
                  v-if="role === 'admin'"
                  class="font-sm primary--text font-family-medium"
                >
                  Capacity
                </h6>
              </b-col>
              <b-col class="" cols="3" :style="{ textAlign: 'right' }">
                <h6
                  v-if="isAdmin()"
                  class="primary--text font-family-medium font-sm"
                  :style="{ paddingRight: '15px' }"
                >
                  Actions
                </h6>
              </b-col>
            </b-row>
          </b-col>

          <b-col class="d-lg-none d-md-none d-sm-none d-none d-xl-flex">
            <b-row class="w-100 justify-space-evenly" no-gutters>
              <b-col cols="5" class="list-view-header">
                <h6
                  class="font-sm position-relative primary--text font-family-medium"
                >
                  EA Name
                </h6>
              </b-col>
              <b-col cols="4" class="list-view-header">
                <h6
                  v-if="role === 'admin'"
                  class="font-sm primary--text font-family-medium"
                >
                  Capacity
                </h6>
              </b-col>
              <b-col class="" cols="3" :style="{ textAlign: 'right' }">
                <h6
                  class="font-sm primary--text font-family-medium"
                  :style="{ paddingRight: '15px' }"
                  v-if="isAdmin()"
                >
                  Actions
                </h6>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="showListView" class="mb-4 position-relative grid-list-row">
          <b-col
            class="grid-list-column"
            md="12"
            xl="6"
            lg="12"
            sm="12"
            cols="12"
            v-for="assistant in assistantsList"
            :key="assistant.id"
          >
            <b-card
              @click="goToPAContactInfo(assistant)"
              @mouseenter="showCardHover(assistant.id)"
              @mouseleave="undoCardHover(assistant.id)"
              class="grid-list-card mt-5 px-0"
              no-body
            >
              <b-card-body class="d-flex text-center grid-list-card-body py-4">
                <b-avatar
                  size="8rem"
                  class="ml-3"
                  v-if="assistant.user.avatarThumbnail"
                  :src="assistant.user.avatarThumbnail"
                ></b-avatar>
                <b-avatar
                  size="8rem"
                  class="ml-3 bg--primary"
                  v-else
                  :text="assistantInitials(assistant.user)"
                ></b-avatar>
                <div
                  class="d-flex flex-column align-items-start justify-content-center ml-4"
                >
                  <p
                    class="text-left font-family-medium primary--text assistant-name mt-2"
                  >
                    {{
                      `${assistant.user.firstName} ${assistant.user.lastName}`
                    }}
                  </p>

                  <p
                    v-if="
                      role === 'admin' && assistant.role.name === 'assistant'
                    "
                    class="secondary--text reduce-whitespace"
                  >
                    {{
                      `${
                        assistant.assistantProfile &&
                        assistant.assistantProfile.workHours
                          ? workHoursToInteger(
                              assistant.assistantProfile.workHours
                            )
                          : ""
                      }`
                    }}
                    hours per/week
                  </p>
                </div>

                <div class="d-flex align-items-center delete-button-wrapper">
                  <template
                    v-if="
                      role === 'admin' && assistant.role.name === 'assistant'
                    "
                  >
                    <div
                      v-if="
                        !deleteHover ||
                          (showInactiveDeleteHover &&
                            activeDeleteHoverId !== assistant.id)
                      "
                      class="empty-icon-avatar d-flex align-items-center justify-content-center"
                    >
                      <img
                        @click.stop="showDeleteModal(assistant)"
                        class="cursor-pointer"
                        src="@/assets/icons/arrow_down_square.svg"
                        alt
                      />
                    </div>
                    <div
                      class="archive-hover-avatar d-flex align-items-center justify-content-center"
                      @click.stop="showDeleteModal(assistant)"
                      v-if="deleteHover && activeDeleteHoverId === assistant.id"
                    >
                      <img
                        src="@/assets/icons/arrow_down_square_hover.svg"
                        alt=""
                      />
                    </div>
                  </template>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <infinite-loading
            spinner="spiral"
            style="width:100%"
            @infinite="infiniteHandlerTeam"
            :identifier="infiniteId"
            ><div slot="no-more">
              <h4 class="primary--text font-family-medium mb-5 mt-5">
                No more EAs to load.
              </h4>
            </div>
            <div slot="no-results">
              <h4 class="primary--text font-family-medium mb-5 mt-5">
                No more EAs to load.
              </h4>
            </div></infinite-loading
          >
        </b-row>
        <b-modal
          centered
          body-class="delete-modal"
          hide-footer
          hide-header
          no-close-on-backdrop
          no-close-on-esc
          v-model="showDelete"
          v-if="showDelete"
        >
          <b-container fluid>
            <b-button
              @click="closeDeleteModal"
              class="d-flex position-absolute close-btn"
            >
              <img
                class="close-icon"
                src="@/assets/icons/close_sidebar.svg"
                alt
              />
            </b-button>
            <b-row
              class="pt-2 d-flex flex-column"
              :style="{ paddingLeft: '15px' }"
            >
              <h2
                v-if="!isPADeleted"
                class="modal_header font-md"
                :style="{ marginBottom: 0 }"
              >
                Are you sure?
              </h2>
              <h2 v-if="isPADeleted" class="modal_header font-md">
                Successfully archived
              </h2>
              <h4 v-if="!isPADeleted" class="font-md subtext">
                Do you want to archive the following EA?
              </h4>
              <h4 v-else class="font-md subtext">
                Following EA has been successfully archived.
              </h4>
            </b-row>
            <b-row align-v="center">
              <b-col class="flex-row d-flex mb-4">
                <div :style="{ paddingRight: '10px' }">
                  <b-avatar
                    v-if="selectedPAAvatar"
                    :src="selectedPAAvatar"
                    size="8rem"
                    class="pa-avatar bg--primary"
                  ></b-avatar>
                  <b-avatar
                    v-else
                    :text="selectedPAInitials"
                    size="8rem"
                    class="pa-avatar bg--primary"
                  ></b-avatar>
                </div>
                <div class="d-flex flex-column position-relative ml-4">
                  <p class="font-family-medium primary--text">
                    {{ selectedPAFullName }}
                  </p>
                  <p class="secondary--text reduce-whitespace">
                    {{
                      parseInt(selectedPA.assistantProfile.workHours) +
                        " hours/week"
                    }}
                  </p>
                  <div class="d-flex reduce-whitespace-2">
                    <b-button
                      class="text-uppercase btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                      >{{ getAssistantJobTitle(selectedJobTitle) }}</b-button
                    >
                  </div>
                </div>
              </b-col>
              <b-button
                @click="removeAssistant"
                v-if="!isPADeleted"
                class="btn-danger px-5 py-3 mr-5 btn-pill reduce-whitespace"
              >
                <b-spinner
                  v-if="isSavingDelete"
                  style="width: 14px; height: 14px"
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                {{ `${isSavingDelete ? "" : deleteBtnText}` }}
              </b-button>
            </b-row>
            <b-row v-if="archiveError" class="archive-error">
              <b-col>
                {{ archiveError }}
              </b-col>
            </b-row>
          </b-container>
        </b-modal>
      </b-tab>
      <!-- Archived EAs -->
      <b-tab title="Archived EAs">
        <b-row>
          <b-col>
            <b-row class="justify-space-evenly list-view-header" no-gutters>
              <b-col cols="5" class="">
                <h6
                  class="font-sm position-relative primary--text font-family-medium"
                >
                  EA Name
                </h6>
              </b-col>
              <b-col cols="4" class="list-view-header">
                <h6
                  v-if="role === 'admin'"
                  class="font-sm primary--text font-family-medium"
                >
                  Capacity
                </h6>
              </b-col>
              <b-col class="" cols="3" :style="{ textAlign: 'right' }">
                <h6
                  v-if="isAdmin()"
                  class="primary--text font-family-medium font-sm"
                  :style="{ paddingRight: '15px' }"
                >
                  Actions
                </h6>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-4 position-relative grid-list-row">
          <b-col
            class="grid-list-column"
            md="12"
            xl="6"
            lg="12"
            sm="12"
            cols="12"
            v-for="assistant in archivedAssistantsList"
            :key="assistant.id"
          >
            <b-card
              @click="goToPAContactInfo(assistant)"
              class="grid-list-card mt-5 px-0"
              no-body
            >
              <b-card-body class="d-flex text-center grid-list-card-body py-4">
                <b-avatar
                  size="8rem"
                  class="ml-3"
                  v-if="assistant.user.avatarThumbnail"
                  :src="assistant.user.avatarThumbnail"
                ></b-avatar>
                <b-avatar
                  size="8rem"
                  class="ml-3 bg--primary"
                  v-else
                  :text="assistantInitials(assistant.user)"
                ></b-avatar>
                <div
                  class="d-flex flex-column align-items-start justify-content-center ml-4"
                >
                  <p
                    class="text-left font-family-medium primary--text assistant-name mt-2"
                  >
                    {{
                      `${assistant.user.firstName} ${assistant.user.lastName}`
                    }}
                  </p>
                  <p
                    v-if="
                      role === 'admin' && assistant.role.name === 'assistant'
                    "
                    class="secondary--text reduce-whitespace"
                  >
                    {{
                      `${
                        assistant.assistantProfile &&
                        assistant.assistantProfile.workHours
                          ? workHoursToInteger(
                              assistant.assistantProfile.workHours
                            )
                          : ""
                      }`
                    }}
                    hours per/week
                  </p>
                </div>

                <div class="d-flex align-items-center delete-button-wrapper">
                  <template
                    v-if="
                      role === 'admin' && assistant.role.name === 'assistant'
                    "
                  >
                    <!-- <div
                      v-if="
                        !archiveHover ||
                          (showInactiveArchiveHover &&
                            activeUnarchiveHoverId !== assistant.id)
                      "
                      class="empty-icon-avatar d-flex align-items-center justify-content-center mr-3"
                    >
                      <img
                        @click.stop="restoreAssistant(assistant)"
                        style="transform: rotate(180deg)"
                        class="cursor-pointer"
                        src="@/assets/icons/arrow_down_square.svg"
                        alt="Restore"
                      />
                    </div>
                    <div
                      class="archive-hover-avatar d-flex align-items-center justify-content-center mr-3"
                      v-if="
                        archiveHover && activeUnarchiveHoverId === assistant.id
                      "
                      @click.stop="restoreAssistant(assistant)"
                    >
                      <img
                        style="transform: rotate(180deg)"
                        src="@/assets/icons/arrow_down_square_hover.svg"
                        alt=""
                      />
                    </div> -->

                    <div
                      v-if="
                        !deleteHover ||
                          (showInactiveDeleteHover &&
                            activeDeleteHoverId !== assistant.id)
                      "
                      class="empty-icon-avatar d-flex align-items-center justify-content-center"
                    >
                      <img
                        @click.stop="showDeletePermanentModal(assistant)"
                        class="cursor-pointer"
                        src="@/assets/icons/card_delete.svg"
                        alt="Delete"
                      />
                    </div>
                    <div
                      class="delete-hover-avatar d-flex align-items-center justify-content-center"
                      v-if="deleteHover && activeDeleteHoverId === assistant.id"
                      @click.stop="showDeletePermanentModal(assistant)"
                    >
                      <img src="@/assets/icons/card_delete_hover.svg" alt="" />
                    </div>
                  </template>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <infinite-loading
            spinner="spiral"
            style="width:100%"
            @infinite="infiniteHandlerArchivedTeam"
            :identifier="archivedInfiniteId"
          >
            <div slot="no-more">
              <h4 class="primary--text font-family-medium mb-5 mt-5">
                No more archived EAs to load.
              </h4>
            </div>
            <div slot="no-results">
              <h4 class="primary--text font-family-medium mb-5 mt-5">
                No more archived EAs to load.
              </h4>
            </div>
          </infinite-loading>
        </b-row>
        <b-modal
          centered
          body-class="delete-modal"
          hide-footer
          hide-header
          no-close-on-backdrop
          no-close-on-esc
          v-model="showDeletePermanent"
          v-if="showDeletePermanent"
        >
          <b-container fluid>
            <b-button
              @click="closeDeletePermanentModal"
              class="d-flex position-absolute close-btn"
            >
              <img
                class="close-icon"
                src="@/assets/icons/close_sidebar.svg"
                alt
              />
            </b-button>
            <b-row
              class="pt-2 d-flex flex-column"
              :style="{ paddingLeft: '15px' }"
            >
              <h2
                v-if="!isPADeletedPermanently"
                class="modal_header font-md"
                :style="{ marginBottom: 0 }"
              >
                Are you sure?
              </h2>
              <h2 v-if="isPADeletedPermanently" class="modal_header font-md">
                Successfully deleted
              </h2>
              <h4 v-if="!isPADeletedPermanently" class="font-md subtext">
                Do you want to permanently delete the following EA? This action
                cannot be undone.
              </h4>
              <h4 v-else class="font-md subtext">
                Following EA has been permanently deleted.
              </h4>
            </b-row>
            <b-row align-v="center">
              <b-col class="flex-row d-flex mb-4">
                <div :style="{ paddingRight: '10px' }">
                  <b-avatar
                    v-if="selectedPAAvatar"
                    :src="selectedPAAvatar"
                    size="8rem"
                    class="pa-avatar bg--primary"
                  ></b-avatar>
                  <b-avatar
                    v-else
                    :text="selectedPAInitials"
                    size="8rem"
                    class="pa-avatar bg--primary"
                  ></b-avatar>
                </div>
                <div class="d-flex flex-column position-relative ml-4">
                  <p class="font-family-medium primary--text">
                    {{ selectedPAFullName }}
                  </p>
                  <p class="secondary--text reduce-whitespace">
                    {{
                      parseInt(selectedPA.assistantProfile.workHours) +
                        " hours/week"
                    }}
                  </p>
                  <div class="d-flex reduce-whitespace-2">
                    <b-button
                      class="text-uppercase btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                      >{{ getAssistantJobTitle(selectedJobTitle) }}</b-button
                    >
                  </div>
                </div>
              </b-col>
              <b-button
                @click="deletePermanently"
                v-if="!isPADeletedPermanently"
                class="btn-danger px-5 py-3 mr-5 btn-pill reduce-whitespace"
              >
                <b-spinner
                  v-if="isSavingDeletePermanent"
                  style="width: 14px; height: 14px"
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                {{ `${isSavingDeletePermanent ? "" : "Confirm Delete"}` }}
              </b-button>
            </b-row>
            <b-row v-if="deleteError" class="delete-error">
              <b-col>
                {{ deleteError }}
              </b-col>
            </b-row>
          </b-container>
        </b-modal>
      </b-tab>
    </b-tabs>

    <b-avatar
      v-if="role === 'admin'"
      button
      @click="$router.push({ name: 'CreatePAAccount' })"
      size="4.8rem"
      class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  archiveOrDeleteAccount,
  unarchiveCustomerAccount
} from "@/apis/customers";
import { getTeam } from "@/apis/common";
import { getAssistantJobTitle, isAdmin, isOwner } from "@/utils/utils";

export default {
  name: "ViewPADirectory",
  created() {
    this.getAssistantsList();
    this.trackView();
  },
  methods: {
    isAdmin,
    getAssistantJobTitle,
    trackView() {
      this.$gtag.event("Team Directory - View", {
        event_category: "feature"
      });
    },
    trackArchive() {
      this.$gtag.event("Team Directory - Archive", {
        event_category: "feature"
      });
    },
    infiniteHandlerTeam($state) {
      let data = {
        limit: 30,
        offset: this.offset
      };
      getTeam(data).then(res => {
        this.assistantsList = [...this.assistantsList, ...res.data.results];
        this.offset = res.data.offset;
        this.loaded = true;
        if (res.data.next === null) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    showCardHover(id) {
      this.activeUnarchiveHoverId = id;
      this.archiveHover = true;
      this.showInactiveArchiveHover = true;
      this.activeDeleteHoverId = id;
      this.deleteHover = true;
      this.showInactiveDeleteHover = true;
    },
    undoCardHover(id) {
      this.inactiveUnarchiveHoverId = id;
      this.archiveHover = false;
      this.inactiveDeleteHoverId = id;
      this.deleteHover = false;
    },
    showDeleteModal(assistant) {
      this.trackArchive();
      let { user, assistantProfile } = assistant;
      this.selectedPA = assistant;
      this.selectedJobTitle = assistantProfile.jobTitle;
      this.selectedPAFullName = `${user.firstName} ${user.lastName}`;
      this.selectedPAInitials = this.selectedPAFullName
        .match(/\b(\w)/g)
        .join("");
      this.showDelete = true;
      this.selectedPAEmail = user.email;
      this.selectedPAAvatar = user.avatarThumbnail;
    },
    removeAssistant() {
      this.isSavingDelete = true;
      const data = {
        profile: this.activeDeleteHoverId
      };
      archiveOrDeleteAccount(data)
        .then(() => {
          this.isPADeleted = true;
          this.assistantsList = this.assistantsList.filter(
            assistant => assistant.id !== this.activeDeleteHoverId
          );
        })
        .catch(err => {
          this.archiveError = err.response.data.detail;
          this.isSavingDelete = false;
        })
        .finally(() => {
          this.isSavingDelete = false;
        });
    },
    closeDeleteModal() {
      this.showDelete = false;
      this.isPADeleted = false;
      this.archiveError = null;
    },
    ...mapActions("assistantsModule", ["actionGetAssistantsList"]),
    getAssistantsList() {},
    goToPAContactInfo(assistant) {
      // Owners are created on the EA account form and have no admin row.
      // Sending them to AdminDetails calls /admins/<id>/ and 404s.
      if (assistant.role.name === "assistant" || assistant.role.name === "owner") {
        const isFullProfile =
          this.defaultProfileId === assistant.id || this.role === "admin";
        // Viewed Owner profiles have no Tasks/Customers — land on Contacts (0).
        const tab =
          assistant.role.name === "owner"
            ? 0
            : isOwner()
            ? 0
            : isFullProfile
            ? 1
            : 0;
        this.$router.push({
          name: "PADetails",
          params: {
            uuid: assistant.id
          },
          query: {
            tab
          }
        });
      } else {
        if (this.defaultProfileId === assistant.id || this.role === "admin") {
          this.$router.push({
            name: "AdminDetails",
            params: {
              uuid: assistant.id
            },
            query: {
              tab: 1
            }
          });
        } else {
          this.$router.push({
            name: "AdminDetails",
            params: {
              uuid: assistant.id
            },
            query: {
              tab: 0
            }
          });
        }
      }
    },
    workHoursToInteger(work_hours) {
      if (work_hours !== null) {
        return Number(work_hours);
      }
    },
    assistantInitials(user) {
      let initials = `${user.firstName} ${user.lastName}`;
      return initials.match(/\b(\w)/g).join("");
    },
    infiniteHandlerArchivedTeam($state) {
      let data = {
        limit: 30,
        offset: this.archivedOffset,
        is_active: false // This will fetch archived EAs
      };
      getTeam(data).then(res => {
        this.archivedAssistantsList = [
          ...this.archivedAssistantsList,
          ...res.data.results
        ];
        this.archivedOffset = res.data.offset;
        if (res.data.next === null) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    restoreAssistant(assistant) {
      unarchiveCustomerAccount(assistant.id)
        .then(() => {
          // Remove from archived list and add to active list
          this.archivedAssistantsList = this.archivedAssistantsList.filter(
            a => a.id !== assistant.id
          );
          this.assistantsList = [assistant, ...this.assistantsList];

          this.$bvToast.toast("EA successfully restored", {
            title: "Success",
            variant: "success",
            solid: true
          });
        })
        .catch(err => {
          this.archiveError = err.response.data.detail || "Error restoring EA";
        });
    },
    getActiveTab() {
      if (this.tabIndex === 1) {
        // Archived tab
        this.archivedOffset = 0;
        this.archivedAssistantsList = [];
        this.archivedInfiniteId = +new Date();
      }
    },
    showDeletePermanentModal(assistant) {
      let { user, assistantProfile } = assistant;
      this.selectedPA = assistant;
      this.selectedJobTitle = assistantProfile.jobTitle;
      this.selectedPAFullName = `${user.firstName} ${user.lastName}`;
      this.selectedPAInitials = this.selectedPAFullName
        .match(/\b(\w)/g)
        .join("");
      this.showDeletePermanent = true;
      this.selectedPAEmail = user.email;
      this.selectedPAAvatar = user.avatarThumbnail;
    },
    closeDeletePermanentModal() {
      this.showDeletePermanent = false;
      this.isPADeletedPermanently = false;
      this.deleteError = null;
    },
    deletePermanently() {
      this.isSavingDeletePermanent = true;
      const data = {
        profile: this.selectedPA.id,
        is_delete: true
      };
      archiveOrDeleteAccount(data)
        .then(() => {
          this.isPADeletedPermanently = true;
          this.archivedAssistantsList = this.archivedAssistantsList.filter(
            assistant => assistant.id !== this.selectedPA.id
          );
        })
        .catch(err => {
          this.deleteError = err.response.data.detail || "Error deleting EA";
        })
        .finally(() => {
          this.isSavingDeletePermanent = false;
        });
    }
  },
  computed: {
    ...mapState("authModule", ["role"])
  },
  data() {
    return {
      defaultProfileId: "",
      max: 10,
      value: 5,
      loaded: false,
      offset: 0,
      infiniteId: +new Date(),
      showListView: false,
      initials: [],
      isLoadingAssistants: true,
      expandHover: false,
      deleteHover: false,
      activeDeleteHoverId: "",
      inactiveDeleteHoverId: "",
      showInactiveDeleteHover: true,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      selectedPAFullName: "",
      selectedJobTitle: "",
      selectedPAInitials: "",
      selectedPA: null,
      showDelete: false,
      isSavingDelete: false,
      isPADeleted: false,
      selectedPAEmail: "",
      selectedPAAvatar: "",
      deleteBtnText: "Confirm Archive",
      assistantsList: [],
      archiveError: null,
      archivedAssistantsList: [],
      archivedOffset: 0,
      archivedInfiniteId: +new Date(),
      showDeletePermanent: false,
      isSavingDeletePermanent: false,
      isPADeletedPermanently: false,
      deleteError: null,
      archiveHover: false,
      activeUnarchiveHoverId: "",
      inactiveUnarchiveHoverId: "",
      showInactiveArchiveHover: true
    };
  }
};
</script>

<style lang="scss" scoped>
.pa-directory-cta {
  bottom: 0.5rem;
  left: 0.5rem;
}
.grid-list-row {
  margin-top: -2rem;
}
.grid-list-wrapper {
  margin-bottom: 4rem;
}
.grid-list-card {
  margin-bottom: -1%;
}
.grid-card:not(:last-child) {
  margin-right: 2%;
}
.grid-card:last-child {
  margin-right: 0;
}
.grid-list-progress-container {
  left: 50%;
  top: 30%;
}
.grid-icon-container {
  right: 0;
  bottom: 30%;
}
.grid-list-action-icons {
  margin-top: -1.5rem;
  top: 40%;
  right: 0;
}
.grid-list-action-icons-hover {
  top: 40%;
  right: 5%;
}
.expand-right {
  right: 6rem;
}
.expand-right-admin {
  right: 1.5rem;
}
.expand-right-pa {
  right: 1.5rem;
}
.delete-right {
  right: 1.5rem;
  bottom: 0;
}
.grid-card-body {
  padding-bottom: 2rem !important;
  margin-top: -2rem;
}
.assistant-name {
  width: 140px;
}
.add-customer-btn-container {
  bottom: 8rem;
  left: 0.5rem;
}
.skeleton-right {
  right: 25%;
}
.skeleton-bottom-left {
  left: 0;
  bottom: -4%;
}
.footer-top {
  top: 5%;
  margin-bottom: -1.5rem !important;
}
.w-20-skeleton {
  width: 20%;
}
.card-expand-icon {
  width: 1.1rem;
  height: 1.1rem;
}
.card-delete-icon {
  width: 1.6rem;
  height: 1.6rem;
  bottom: 0.4rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}

.pa-directory-container {
  margin-bottom: 10rem;
}

.floating-action-btn {
  right: 3rem;
  bottom: 0;
  z-index: 2;
}
::v-deep .delete-modal.modal-body {
  padding: 2rem;
  h4.subtext {
    padding-bottom: 2.5rem;
  }
}
.card {
  cursor: pointer;
}
.delete-button-wrapper {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.list-view-header {
  padding-left: 2.25rem;
}
/*@media (min-width: 1200px) {
  .card-column {
      flex: 0 0 20%;
      max-width: 25%;
  }
}*/
// X-Small devices (portrait phones, less than 576px)
@media (min-width: 0px) {
  .card-column {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .card-column {
    flex: 0 0 100%;
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .card-column {
    flex: 0 0 50%;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .card-column {
    flex: 0 0 25%;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  .card-column {
    flex: 0 0 25%;
  }
}

// XX-Large devices (larger desktops, 1400px and up)
@media (min-width: 1400px) {
  .card-column {
    flex: 0 0 20%;
  }
}

.empty-icon-avatar {
  &.mr-3 {
    margin-right: 1rem;
  }
}

.delete-error {
  color: var(--danger);
  margin-top: 1rem;
}

.archive-hover-avatar,
.delete-hover-avatar {
  cursor: pointer;
}
</style>
